import { createContext } from 'react';

export const ImageContext = createContext(null);